import { Controller } from "@hotwired/stimulus"

// Widget visuel de disponibilités hebdomadaires pour les consultations.
// Chaque ligne = un jour avec un toggle on/off + 1 ou 2 plages horaires.
// La valeur sérialisée "HH:MM-HH:MM, HH:MM-HH:MM" est calculée à la
// volée dans l'input hidden de la row, prête à être soumise au serveur.
export default class extends Controller {
  static targets = ["row"]

  connect() {
    this.rowTargets.forEach((row) => {
      this._wireRow(row)
      this._sync(row)
    })
  }

  toggleDay(event) {
    const row = event.currentTarget.closest("[data-consult-availability-target='row']")
    if (!row) return
    const on = event.currentTarget.checked
    row.classList.toggle("is-open", on)
    this._sync(row)
  }

  addSlot(event) {
    const row = event.currentTarget.closest("[data-consult-availability-target='row']")
    if (!row) return
    const slots = row.querySelectorAll(".consult-avail-slot")
    if (slots.length < 2) return
    slots[1].hidden = false
    event.currentTarget.hidden = true
    this._sync(row)
  }

  removeSlot(event) {
    const row = event.currentTarget.closest("[data-consult-availability-target='row']")
    if (!row) return
    const slot1 = row.querySelector("[data-slot-idx='0']")
    const slot2 = row.querySelector("[data-slot-idx='1']")
    if (!slot2) return
    slot2.hidden = true
    const addBtn = slot1?.querySelector("[data-consult-availability-target='addBtn']")
    if (addBtn) addBtn.hidden = false
    this._sync(row)
  }

  // Bind change events on all time inputs to re-sync the hidden output.
  _wireRow(row) {
    row.querySelectorAll(".consult-avail-time").forEach((input) => {
      input.addEventListener("change", () => this._sync(row))
      input.addEventListener("input",  () => this._sync(row))
    })
  }

  // Recompute the serialized string "HH:MM-HH:MM, HH:MM-HH:MM" from the
  // visible state and push it into the hidden input that the server reads.
  _sync(row) {
    const output = row.querySelector("[data-consult-availability-target='output']")
    const toggle = row.querySelector("[data-consult-availability-target='dayToggle']")
    if (!output || !toggle) return

    if (!toggle.checked) {
      output.value = ""
      return
    }

    const parts = []
    row.querySelectorAll(".consult-avail-slot").forEach((slot) => {
      if (slot.hidden) return
      const s = slot.querySelector("[data-role='start']")?.value
      const e = slot.querySelector("[data-role='end']")?.value
      if (s && e && s < e) parts.push(`${s}-${e}`)
    })
    output.value = parts.join(", ")
  }
}
